import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import React from 'react';
import {IMatchPairQuestion, IElementQuestionMatchPair} from '../../../../../incase-domain/elements/question/questionMatchPair';
import {swapArrayIndices} from '../../../../../utils/utils';
import Button from '../../../../../incase-domain/components/button/Button';

interface HighlightedChangeElementOrderProps {
    highlightedElementArrayToDisplay: IMatchPairQuestion[];
    highlightedElementsToChangeOrder: string;
    highlightedElementChangeHandler: {
        single: (field: keyof IElementQuestionMatchPair | string, value: unknown) => void;
    };
}

function HighlightedChangeElementOrder(props: HighlightedChangeElementOrderProps): JSX.Element {
    const {highlightedElementChangeHandler, highlightedElementArrayToDisplay, highlightedElementsToChangeOrder} = props;

    function swapAnswerOrderHandler(
        elementsToChangeOrder: IMatchPairQuestion[],
        newIndex: number,
        oldIndex: number,
        elementToChangeOrder: string,
        highlightedElementChangeHandler: {
            single: (field: string, value: unknown) => void;
        }
    ): void {
        const newAnswers = swapArrayIndices(elementsToChangeOrder, newIndex, oldIndex);
        highlightedElementChangeHandler.single(elementToChangeOrder, newAnswers);
    }

    return (
        <DragDropContext
            onDragEnd={(e) => {
                if (typeof e.destination?.index !== 'undefined')
                    swapAnswerOrderHandler(
                        highlightedElementArrayToDisplay,
                        e.destination.index,
                        e.source.index,
                        highlightedElementsToChangeOrder,
                        highlightedElementChangeHandler
                    );
            }}
        >
            <Droppable droppableId={`droppable-${highlightedElementsToChangeOrder}`}>
                {(provided) => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                        {highlightedElementArrayToDisplay
                            .filter((item, index, self) => self.findIndex((t) => t.text === item.text) === index)
                            .map((answer: IMatchPairQuestion, index) => {
                                return (
                                    <Draggable key={`draggable-${index}`} draggableId={`${index}-order}`} index={index}>
                                        {(provided) => {
                                            return (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    key={`highlighted-element-matchPair-${index}-${highlightedElementsToChangeOrder}`}
                                                    className="u-mt-1"
                                                >
                                                    <Button
                                                        className="c-matchPairQuestionElement__button"
                                                        variant="soft"
                                                        fullWidth
                                                        disablePointerEvents
                                                        trailing="material-symbols:drag-indicator"
                                                    >
                                                        {answer.text}
                                                    </Button>
                                                </div>
                                            );
                                        }}
                                    </Draggable>
                                );
                            })}

                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
}

export default HighlightedChangeElementOrder;
